<template>
  <div>
    <a-modal
      title="循环导入"
      :visible="isShow"
      width="700px"
      okText="确定"
      cancelText="取消"
      @ok="isShow = false"
      class="customermodel"
      @cancel="isShow = false"
      :confirmLoading="isSaving"
    >
      <div class="editsimulationfood-model">
        <a-form-model
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
        >
          <a-form-model-item label="模板">
            <a-button @click="downloadAutoTemplate()">
              下载
            </a-button>
          </a-form-model-item>
          <a-form-model-item label="早餐">
            <a-radio-group @change="modeOnChange($event, 'breakfast')" v-model="breakfastMode">
              <a-radio :value="1">
                循环
              </a-radio>
              <a-radio :value="2">
                随机
              </a-radio>
            </a-radio-group>
            <a-upload
            name="file"
            :withCredentials="true"
            :showUploadList="false"
            accept=".xlsx"
            :action="breakfastUploadUrl"
            :beforeUpload="onBeforeUpload"
            @change="handleChange"
            :data="{school_id:currentSchool._id}"
            >
            <a-button
              size="large"
              :loading="isUploading"
            >导入循环菜单</a-button>
            </a-upload>
            <a :disabled="exporting" @click="downloadAuto('breakfast')">&nbsp;&nbsp;下载</a>
          </a-form-model-item>
          <a-form-model-item label="午餐">
            <a-radio-group @change="modeOnChange($event, 'lunch')" v-model="lunchMode">
              <a-radio :value="1">
                循环
              </a-radio>
              <a-radio :value="2">
                随机
              </a-radio>
            </a-radio-group>
            <a-upload
            name="file"
            :withCredentials="true"
            :showUploadList="false"
            accept=".xlsx"
            :action="lunchUploadUrl"
            :beforeUpload="onBeforeUpload"
            @change="handleChange"
            :data="{school_id:currentSchool._id}"
            >
            <a-button
              size="large"
              :loading="isUploading"
            >导入循环菜单</a-button>
            </a-upload>
            <a :disabled="exporting" @click="downloadAuto('lunch')">&nbsp;&nbsp;下载</a>
          </a-form-model-item>
          <a-form-model-item label="晚餐">
            <a-radio-group @change="modeOnChange($event, 'dinner')" v-model="dinnerMode">
              <a-radio :value="1">
                循环
              </a-radio>
              <a-radio :value="2">
                随机
              </a-radio>
            </a-radio-group>
            <a-upload
            name="file"
            :withCredentials="true"
            :showUploadList="false"
            accept=".xlsx"
            :action="dinnerUploadUrl"
            :beforeUpload="onBeforeUpload"
            @change="handleChange"
            :data="{school_id:currentSchool._id}"
            >
            <a-button
              size="large"
              :loading="isUploading"
            >导入循环菜单</a-button>
            </a-upload>
            <a :disabled="exporting" @click="downloadAuto('dinner')">&nbsp;&nbsp;下载</a>
          </a-form-model-item>
        </a-form-model>
        </div>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import apis from '@/business/apis'
import downloadjs from 'downloadjs'

const formItemLayout = {
  labelCol: { span: 2 },
  wrapperCol: { span: 20 }
}
const formTailLayout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 18 }
}

export default {
  name: 'AutoDailyFoodMenu',
  inject: ['eventBus'],
  data: () => ({
    id: false,
    autoUploadUrl: apis.dailyFoodMenu.importAutoExcel,
    isShow: false,
    breakfastMode: null,
    lunchMode: null,
    dinnerMode: null,
    isSaving: false,
    exporting: false,
    formItemLayout,
    formTailLayout
  }),
  computed: {
    ...mapState('school', ['currentSchool']),
    breakfastUploadUrl () {
      const nextIndex = this.breakfastMode === 1 ? 0 : -1
      return `${this.autoUploadUrl}?meal=breakfast&nextIndex=${nextIndex}`
    },
    lunchUploadUrl () {
      const nextIndex = this.lunchMode === 1 ? 0 : -1
      return `${this.autoUploadUrl}?meal=lunch&nextIndex=${nextIndex}`
    },
    dinnerUploadUrl () {
      const nextIndex = this.dinnerMode === 1 ? 0 : -1
      return `${this.autoUploadUrl}?meal=dinner&nextIndex=${nextIndex}`
    }
  },
  methods: {
    async show () {
      await this.loadDetail()
      this.isShow = true
    },
    addFood () {
      this.dailyFoodMenu.foods.push({ name: '' })
    },
    removeFood (index) {
      this.dailyFoodMenu.foods.splice(index, 1)
    },
    checkInput (type, item) {
      if (type === 'name') {
        if (item.name.length > 20) {
          item.name = item.name.substr(0, 20)
        }
      } else if (type === 'weight') {
        item.weight = item.weight
          .replace(/[^\d.]/g, '')
          .replace(/\.{2,}/g, '.')
          .replace('.', '$#$')
          .replace(/\./g, '')
          .replace('$#$', '.')
          .replace(/^(\\-)*(\d+)\.(\d\d).*$/, '$2.$3')
          .replace(/^\./g, '')
        item.weight = Number(item.weight) || undefined
      }
    },
    async loadDetail () {
      const response = await this.$http.get(`${apis.dailyFoodMenu.auto}?schoolId=${this.currentSchool._id}`)
      const { data } = response.body
      console.log(data)
      if (data?.breakfast?.next_index === -1) {
        this.breakfastMode = 2
      } else if (data?.breakfast?.next_index >= 0) {
        this.breakfastMode = 1
      }
      if (data?.lunch?.next_index === -1) {
        this.lunchMode = 2
      } else if (data?.lunch?.next_index >= 0) {
        this.lunchMode = 1
      }
      if (data?.dinner?.next_index === -1) {
        this.dinnerMode = 2
      } else if (data?.dinner?.next_index >= 0) {
        this.dinnerMode = 1
      }
    },
    async downloadAutoTemplate () {
      this.downloadFile(apis.file.static + '导入循环菜单模板.xlsx')
    },
    async downloadAuto (meal) {
      this.exporting = true
      const response = await this.$http.post(
        apis.dailyFoodMenu.exportAuto,
        {
          schoolId: this.currentSchool._id,
          meal
        },
        { responseType: 'blob' }
      )
      if (!response || !response.ok) {
        this.$message.info('导出失败')
        return
      }
      downloadjs(
        await response.blob(),
        `${this.currentSchool.name}_${moment().format('YYYYMMDDTHHmmss')}.xlsx`,
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      )
      setTimeout(() => {
        this.exporting = false
      }, 2000)
    },
    async downloadFile (url) {
      console.log('download', url)
      let e = window.document.getElementById('_staticFileLink')
      if (!e) {
        e = window.document.createElement('a')
        e.setAttribute('id', '_staticFileLink')
      }
      e.setAttribute('href', url)
      e.click()
    },
    async onBeforeUpload (file) {
      const maxSize = 10 * 1000 * 1000
      if (file.size > maxSize) {
        this.$message.error('文件大小不可以超过10M')
        return Promise.reject(Error())
      }
      this.$message.info('正在导入...')
    },
    async handleUploadFinish (result) {
      this.$message.destroy()
      if (result.err) {
        this.$message.error(result.errMsg)
        return
      }
      this.downloadFile(apis.file.runtime + result.name)
      this.loadList()
      this.$message.success(`导入完成，成功${result.nSuccessed}条，失败${result.nFailed}条，详情请查看导入菜单结果`, 5)
    },
    handleChange ({ file }) {
      switch (file.status) {
        case 'uploading':
          this.isUploading = true
          break
        case 'done':
          this.isUploading = false
          this.handleUploadFinish(file.response)
          break
        case 'error':
          this.isUploading = false
          this.$message.error('上传失败')
          break
      }
    },
    async modeOnChange ({ target: { value: mode } }, meal) {
      const response = await this.$http.post(`${apis.dailyFoodMenu.updateNextIndex}?schoolId=${this.currentSchool._id}&meal=${meal}`, {
        next_index: mode === 1 ? 0 : -1
      })
      const { success, msg } = response.body
      console.log({ success, msg })
      if (success) {
        if (msg) {
          this.$message.success(msg)
        }
      } else {
        this.$message.error('操作失败')
      }
    }
  },
  created () {
    this.eventBus.$on('show-daily-food-menu-auto', this.show)
  },
  beforeDestroy () {
    this.eventBus.$off('show-daily-food-menu-auto', this.show)
  }
}
</script>
